import '../../../../../vendor/mark.js/dist/mark';
import * as StringUtils from '../../utils/string-utils';
import { nodeChangeListenerServiceModule } from '../../services/node-change-listener/node-change-listener';

function stringifyMatchers(matchers) {
  if (!Array.isArray(matchers)) matchers = [matchers];
  return matchers
    .map((m) => m.keyword.toString() + JSON.stringify(m))
    .join('|');
}

export const highlightMatchesComponentModule = angular
  .module('Q.components.highlight-matches', [nodeChangeListenerServiceModule])

  .directive(
    'highlightMatches',
    function ($window, $timeout, nodeChangeListener) {
      function isRegex(o) {
        return o instanceof RegExp;
      }

      const defaultProps = {
        separateWordSearch: false,
        diacritics: false,
        acrossElements: true,
      };

      return {
        restrict: 'A',
        scope: {
          highlightMatchesOptions: '<',
          highlightMatchesEach: '&',
          highlightMatchesDone: '&',
        },
        link(scope, elem, attr) {
          if (!$window.Mark) return;

          let marker = new $window.Mark(elem[0]);

          // When greater than 0, we don't make any changes
          let isHighlighting = 0;
          let needsHighlight = false;

          const getMatchers = () =>
            scope.$parent.$eval(attr.highlightMatches) || [];

          function highlight() {
            if (isHighlighting) {
              needsHighlight = true;
              return;
            }

            // set to 1, then increment up for each className/kw combo
            isHighlighting = 1;
            // clean up previous matches
            marker.unmark();

            const options = scope.highlightMatchesOptions || {};

            let matches = getMatchers();
            if (!angular.isArray(matches)) {
              matches = [matches];
            }

            angular.forEach(matches, (config) => {
              if (!angular.isObject(config) || isRegex(config)) {
                config = { keyword: config };
              }

              let keyword = config.keyword;
              if (!keyword) return;

              isHighlighting++;

              const markOpts = angular.extend(
                {},
                defaultProps,
                options,
                config,
                {
                  each(node) {
                    scope.highlightMatchesEach({ config, keyword, node });
                    if (config.each) config.each(node);
                  },
                  done(total) {
                    scope.highlightMatchesDone({ config, keyword, total });
                    if (config.done) config.done(total);
                    // decrement for each className/kw combo we've completed
                    isHighlighting--;
                  },
                },
              );

              if (!isRegex(keyword) && /\s/.test(keyword)) {
                // Mark.js doesn't handle whitespace very well
                keyword = new RegExp(
                  StringUtils.escapeRegex(keyword),
                  markOpts.caseSensitive ? '' : 'i',
                );
              }

              if (isRegex(keyword)) {
                marker.markRegExp(keyword, markOpts);
              } else {
                marker.mark(keyword, markOpts);
              }
            });

            $timeout(
              () => {
                // decrement by 1 since we've either added in each kw, or we found no kws
                // delayed to make sure we don't end up causing a loop with constant re-highlighting
                isHighlighting--;
                if (needsHighlight) {
                  needsHighlight = false;
                  highlightLater();
                }
              },
              100,
              false,
            );
          }

          let highlightTimer = null;

          function highlightLater() {
            if (isHighlighting) return;
            if (highlightTimer) $timeout.cancel(highlightTimer);
            highlightTimer = $timeout(highlight, 250, false);
          }

          highlight();

          //// Change Watchers

          scope.$watch(() => stringifyMatchers(getMatchers()), highlight);

          const nodeChangeListenerStop = nodeChangeListener.listen(
            elem,
            highlightLater,
          );

          scope.$on('$destroy', () => {
            nodeChangeListenerStop();
          });
        },
      };
    },
  );
